// Lives here rather than alongside the Booking component so helpers can compare
// against it without importing from a component (which would be circular).
export enum BookingType {
  OWNER = 'OWNER STAY',
  PRIVATE_LET = 'PRIVATE LET',
  MAINTENANCE = 'OWNER MAINTENANCE',
  PROMOTE_LETTING = 'PROMOTE LETTING',
  LET_WITH_HAVEN = 'HAVEN LET',
}
